/**
 * {"trx_no":"2021042344939",
 *    "trx_date":"2021-04-23T05:20:40.147Z",
 *    "member_tier":{},"member_badge":{},
 *    "summary":{"total_transaction":18,
 *              "total_payment":57018,
 *              "total_revenue":57018,
 *              "total_discount":0,
 *              "total_outstanding":0,
 *              "total_qty":0,"wallet":{}}}}
 */

class PaymentResult {
  constructor({ trx_no, trx_date, summary }) {
    this.id = trx_no;
    this.date = trx_date;
    this.remainingPoint = summary?.wallet?.pocket?.reward?.available;
  }
  getPayloadData() {
    return {
      id: this.id,
      date: this.date,
      remainingPoint: this.remainingPoint,
    };
  }
}

export default PaymentResult;
